const faqs = [
  {
    q: '51黑料网的信息来源可靠吗？',
    a: '51黑料网的信息来源包括公开媒体报道、社交媒体平台公开信息以及可靠爆料人投稿。我们的编辑团队会对每一条信息进行多方核实，确保内容的真实性和准确性。对于无法完全确认的信息，我们会明确标注"待核实"标签，让吃瓜群众理性判断。',
  },
  {
    q: '51黑料网的内容是否真的完全免费？',
    a: '是的，51黑料网始终坚持免费开放原则。所有文章、视频和专题内容均可免费浏览，无需注册登录，不存在付费墙或会员制度。我们通过广告收入维持运营，绝不以任何形式向读者收费。吃瓜是每个人的权利，我们说到做到。',
  },
  {
    q: '如何向51黑料网投稿爆料？',
    a: '你可以通过本站投稿通道联系我们。所有投稿均采用匿名处理，我们将严格保护爆料人的隐私信息。投稿内容经编辑团队核实后发布，重大独家爆料还将获得相应稿酬。欢迎点击上方"投稿爆料"区域了解详情。',
  },
  {
    q: '51黑料网的内容更新频率如何？',
    a: '51黑料网实行全天候更新机制，编辑团队7×24小时监控娱乐圈动态，确保第一时间为吃瓜群众送上最新猛料。平均每天更新内容超过50篇，重大突发事件保证30分钟内上线相关报道，让你永远不会错过任何一个大瓜。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">常见问题</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">常见问题</h2>
          <p className="text-foreground-600 text-sm mt-2">关于51黑料网，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <h3 className="text-base font-bold text-foreground-900 mb-3 flex items-start gap-2">
                <span className="text-primary-500 font-bold flex-shrink-0">Q:</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}